/**
 * Get linked SVG Icon code for given icon name.
 *
 * Usage:
 *   const svgIcons = new SVGIcons(); // in DOMContentReady/load
 *   svgIcons('arrow-up');
 *
 */

class SVGIcons {
  /**
   * @param {string} [iconURL] - URL pointing to svg icon library. If undefined, tries to get it from global `SYMBOLS_URI` variable.
   * @param {string} [iconClass] - Classname for icons
   *
   * @returns {function} - Bound getIcon function
   */
  constructor(iconURL = null, iconClass= 'icon') {
    this.iconClass = iconClass;
    this.iconURL = iconURL ?
      iconURL :
      typeof window.SYMBOLS_URI === 'string' ?
        window.SYMBOLS_URI :
        'icon-symbols.svg';
    return this.getIcon.bind(this);
  }

  /**
   * @param {string} iconName - The name of the icon to retreive
   * @param {(string|array)} [extraClasses] - Optional extra classes to be added to the container element
   *
   * @return {string} - HTML markup for the requested icon.
   */
  getIcon(iconName, extraClasses = null) {
    if(Array.isArray(extraClasses)) {
      extraClasses = extraClasses.reduce((a, v) => a + ' ' + v, ' ');
    } else if(!extraClasses) {
      extraClasses = '';
    }

    return `
<i class="${ this.iconClass } ${ this.iconClass }--${ iconName } ${ extraClasses }">
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
    <use xlink:href="${this.iconURL}#${iconName}" />
  </svg>
</i>`;
  }
}

export default SVGIcons;
